// KundenstreckeFormSuccess.jsx
import React, { useEffect } from 'react';
import FileUploader from '../../custom_elements/FileUploader';

export default function Form6({
    nextForm,
    passGetFormData,
    passValidateAllFormFields,
    retrievedFormData = {},
    sendChat
}) {

    const backendUrl = process.env.REACT_APP_DOMAIN_BACKEND;

    const getFormData = () => {
        console.log("INSIDE GETFORMDATA on Form7");
        const form = document.getElementById('Form7');
        const formData = new FormData(form);
        const data = {};
        for (let [key, value] of formData.entries()) {
            data[key] = value;
        }
        return { person: [data], kommentar: formData.get('kommentar') };
    };

    useEffect(() => {
        console.log('Form7 mounted');
        passGetFormData(() => getFormData); 
    }, [passGetFormData]);

    return (
        <div className="formFieldBox">
            <form id="Form7">
                <div
                    className="success-message-container"
                    style={{ marginTop: "30px", textAlign: "center" }}
                >
                    <div style={{ fontSize: "60px", color: "green" }}>✔</div>
                    <h2 style={{ color: "green", marginTop: "10px" }}>Vielen Dank!</h2>
                    <p>
                        Deine Anfrage wurde erfolgreich übermittelt. 
                        Wir melden uns in Kürze bei dir!
                    </p>
                </div>
            </form>
            
            {/* ---------------------- */}
            {/*   FILE UPLOADER START  */}
            {/* ---------------------- */}

            <FileUploader
                backendUrl={backendUrl}
                benutzer_id={localStorage.getItem("userid")}
                user_token={localStorage.getItem("user_token")}
            />

            {/* ------------------- */}
            {/*   FILE UPLOADER END */}
            {/* ------------------- */}
        </div>
    );
}
